import Vue from 'vue';
import VueRouter, {Route} from 'vue-router';
import Home from '../views/Home.vue';

import Fetch from '@/lib/fetch.ts';
import SinglePost from '@/views/SinglePost.vue';
import About from '@/views/About.vue';
import Sandbox from '@/views/Sandbox.vue';
import Auth from '@/views/Auth.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {title: 'Home'},
    children: [
        {
          path: '',
          components: {
            Posts: () => import(/* webpackChunkName: "home" */ '../components/PostEnumerator.vue'),
            Weather: () => import(/* webpackChunkName: "home" */ '../components/WeatherBox.vue'),
          },
        },
    ],
  },
  {
    path: '/singlepost/:link',
    name: 'post',
    component: SinglePost,
    meta: {title: 'Single Post'},
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: {title: 'About'},
  },
  {
    path: '/sandbox',
    name: 'sandbox',
    component: Sandbox,
    meta: {title: 'Sandbox'},
  },
  {
    path: '/(admin|login|register)',
    name: 'admin',
    component: Auth,
    meta: {title: 'Auth'},
    beforeEnter: async (to: any, from: any, next: (vm?: any) => void) => {
      if (Vue.$cookies.get('authenticated')) {
        next('/management');
      } else {
        next();
      }
    },
  },
  {
    path: '/management',
    name: 'manage',
    component: () => import(/* webpackChunkName: "admin" */ '../views/Management.vue'),
    meta: {title: 'Management'},
    children: [
      {
        path: '',
        components: {
          'Post Editor': () => import(/* webpackChunkName: "admin" */ '../components/PostEditor.vue'),
          'Code Block Editor': () => import(/* webpackChunkName: "admin" */ '../components/CodeBlockEditor.vue'),
          'Sandbox Code List': () => import(/* webpackChunkName: "admin" */ '../components/SandboxCodeList.vue'),
          'Weather Control': () => import(/* webpackChunkName: "admin" */ '../components/WeatherControl.vue'),
          'Post List': () => import(/* webpackChunkName: "admin" */ '../components/PostList.vue'),
          'Visitors': () => import(/* webpackChunkName: "admin" */ '../components/Analytics.vue'),
        },
      },
    ],
    beforeEnter: async (to: Route, from: Route, next: (vm?: any) => void) => {
      const authenticated: boolean = await Fetch.post('/api/authstatus',
          { user: Vue.$cookies.get('user'), token: Vue.$cookies.get('token') });
      if (authenticated) {
        next();
      } else {
        Vue.$cookies.remove('authenticated');
        next('/admin');
      }
    },
  },

  // pe: () => import(/* webpackChunkName: "admin" */ '../components/PostEditor.vue'),
  // cbe: () => import(/* webpackChunkName: "admin" */ '../components/CodeBlockEditor.vue'),
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to: Route, from: Route, next: (vm?: any) => void) => {
  window.document.title = `Jared Bell - ${to.meta.title ? to.meta.title : 'Home'}`;
  const headers = new Headers();
  headers.append('X-Route', to.fullPath);
  await Fetch.get('/api/visitor/log', { headers });
  next();
});

export default router;
